import { Users, DollarSign, PhoneCall, CalendarCheck, ShoppingBag } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const METRICS = [
  { id: "leads", icon: Users, title: "Leads", copy: "How many real prospects came in?" },
  { id: "cost-per-lead", icon: DollarSign, title: "Cost Per Lead", copy: "How efficiently are we acquiring opportunities?" },
  { id: "phone-calls", icon: PhoneCall, title: "Phone Calls", copy: "How many people contacted your business?" },
  { id: "appointments", icon: CalendarCheck, title: "Appointments", copy: "How many prospects moved forward?" },
  { id: "customers", icon: ShoppingBag, title: "Customers", copy: "How much actual business did the campaign create?" },
];

export const Metrics = () => (
  <section className="relative bg-[#FAFAFA] py-12 text-[#0A0A0F] sm:py-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow className="text-purple-600">What We Measure</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl">
          The Metrics We Care About.
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {METRICS.map((m, i) => (
          <Reveal key={m.id} delay={0.06 * i} className="h-full">
            <div
              data-testid={`metric-card-${m.id}`}
              className="group flex h-full flex-col rounded-2xl border border-black/10 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-purple-600/50 hover:shadow-xl hover:shadow-purple-600/10"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-purple-600/10 text-purple-600 transition-colors duration-300 group-hover:bg-purple-600 group-hover:text-white">
                <m.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 font-display text-xl font-extrabold uppercase tracking-tight">
                {m.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-600">{m.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-12 font-display text-4xl font-extrabold leading-[0.95] tracking-tighter sm:text-5xl lg:text-7xl">
          Likes don't pay the bills.
          <span className="block text-purple-600">Customers do.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
